export enum AnimationDuration {
  Chart = 1000,
}
